import axios from 'axios'
import { EXCLUIR_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirEmpresa (codEmpresa) {
  const url = `${URL}/empresas/excluir/${codEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_EMPRESA,
        payload: response

      })
  );
}
